import { FormattedMessage } from 'react-intl'
import { EventCategory } from '@/shared/types'
import { strings } from './CategorySelector.strings'

export const CategoryLabelMap: Record<EventCategory, React.ReactElement> = {
  wedding: <FormattedMessage {...strings.wedding} />,
  'baby-shower': <FormattedMessage {...strings.babyShower} />,
  birthday: <FormattedMessage {...strings.birthday} />,
  funeral: <FormattedMessage {...strings.funeral} />,
  other: <FormattedMessage {...strings.other} />,
}
